import axios from '../axios';

// 分页列表
export const getSysPaymentChannelPage = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/getSysPaymentChannelPage',
    method: 'post',
    data
  })
};

// 合计行
export const getSysPaymentChannelSum = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/getSysPaymentChannelSum',
    method: 'post',
    data
  })
};

// 查询单条（按ID）
export const getSysPaymentChannel = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/getSysPaymentChannel',
    method: 'post',
    data
  })
};

// 新增保存
export const saveSysPaymentChannel = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/saveSysPaymentChannel',
    method: 'post',
    data
  })
};

// 修改更新
export const updateSysPaymentChannel = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/updateSysPaymentChannel',
    method: 'post',
    data
  })
};

// 批量删除
export const deleteSysPaymentChannels = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/deleteSysPaymentChannels',
    method: 'post',
    data
  })
};

// 批量确认（auditFlag = 1）
export const auditSysPaymentChannels = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/auditSysPaymentChannels',
    method: 'post',
    data
  })
};

// 批量反确认（auditFlag = 0）
export const unauditSysPaymentChannels = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/unauditSysPaymentChannels',
    method: 'post',
    data
  })
};

// ==========================
// 游乐园支付渠道参数（Config）
// ==========================

// 分页列表
export const getSysPaymentChannelConfigPage = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/config/getSysPaymentChannelConfigPage',
    method: 'post',
    data
  })
};

// 查询单条（按ID）
export const getSysPaymentChannelConfig = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/config/getSysPaymentChannelConfig',
    method: 'post',
    data
  })
};

// 新增保存
export const saveSysPaymentChannelConfig = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/config/saveSysPaymentChannelConfig',
    method: 'post',
    data
  })
};

// 修改更新
export const updateSysPaymentChannelConfig = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/config/updateSysPaymentChannelConfig',
    method: 'post',
    data
  })
};

// 批量删除
export const deleteSysPaymentChannelConfigs = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/config/deleteSysPaymentChannelConfigs',
    method: 'post',
    data
  })
};

// 审核（配置）
export const auditSysPaymentChannelConfig = data => {
  return axios({
    url: '/api/sys/sys/payment/channel/config/auditSysPaymentChannelConfig',
    method: 'post',
    data
  })
};




// WEBPACK FOOTER //
// ./src/api/moudules/SysPaymentChannel.js